import { AdjustmentTypeDroOpts } from "presentation/constant/DropDownOptions/Charge/AdjustmentTypeDroOpts";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const AdjustmentAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "330px" }}>
                    <NbisCommonField
                        errorMessage={chargeBatchUpdate.allFormState?.["adjustmentType"] ?? ""}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.adjustmentType ?? ""}
                        fieldValue={chargeBatchUpdate.adjustmentType}
                        fieldLabel={"Adjustment Type"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'adjustmentType'}
                        maxLength={60}
                        options={AdjustmentTypeDroOpts().getAdjustmentTypeModel().filter(type => (type.tagLabel !== "NORMAL" && type.tagLabel !== "RECAL" && type.tagLabel !== "CANCEL_REBILL_TO_OTHER_COMPANY"))}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>
            </div>

        </>
    )
}